<script setup lang="ts">
import {ref} from "vue";
import {ElNotification} from "element-plus";
import {SimpleRecordVideo} from "@/types";
import {SectionService} from "@/api/api.ts";
import {getDurationStr} from "@/utils/common.ts";

const visible = ref(false)
const content = ref('')
const videos = ref<SimpleRecordVideo[]>([])

const getVideoList = async () => {
  try {
    const res = await SectionService.getRecordVideoList({
      content: content.value,
    })
    if (res.data.code === 200) {
      videos.value = res.data.data || []
    } else {
      ElNotification.error({
        title: '获取课程列表失败',
        message: res.data.msg,
        type: 'error',
      })
    }
  } catch (e) {
    console.warn(e)
  }
}

const show = () => {
  visible.value = true
  getVideoList()
}

const hide = () => {
  visible.value = false
}

const onClose = () => {
  content.value = ''
  videos.value = []
}

const emit = defineEmits(['on-select-video', "on-preview-video"])

const onSelectVideo = (videoId: string, filename: string) => {
  emit('on-select-video', videoId, filename)
}

const onPreviewVideo = (videoId: string) => {
  emit('on-preview-video', videoId)
}

defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog v-model="visible" title="已上传视频列表" @close="onClose">
    <div class="flex items-center">
      <el-input style="width: 20rem" v-model="content" type="text" placeholder="请输入搜索内容" @change="getVideoList"/>
      <el-button class="ml-1rem" type="primary" @click="getVideoList">搜索</el-button>
    </div>
    <el-table :data="videos" style="width: 100%" class="mt-1rem">
      <el-table-column prop="id" label="视频ID"></el-table-column>
      <el-table-column prop="file_name" label="视频名称"></el-table-column>
      <el-table-column prop="duration" label="视频时长">
        <template #default="scope">
          {{ getDurationStr(scope.row.duration) }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button
              type="primary"
              @click="onSelectVideo(scope.row.video_id, scope.row.file_name)">选择视频
          </el-button>
          <el-button
              type="info"
              @click="onPreviewVideo(scope.row.video_id)">预览
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<style scoped>
</style>
